import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Users } from "./users.model";
import { Approver } from "./approver.model";
import { ContractService } from "../contract/shared/contract.service";
import { Onboarding } from "./onboarding.model";
import { ModulesSubmodulesPermissionsByRole } from "../contract/shared/modules-submodules-permissions-by-role.model";
import { Permissions } from "./permissions.model";
import { ModulesSubmodulesPermissionsMaster } from "../contract/shared/modules-submodules-permissions-master.model";
import { ToastrService } from "ngx-toastr";
import { Organisation } from "./organisation.model";


@Injectable({
  providedIn: "root",
})
export class UserService {
  permissionTypes = {
    PERMISSIONS: {
      "1": "ADD_",
      "2": "EDIT_",
      "3": "VIEW_",
      "4": "DELETE_",
      "5": "UPLOAD_",
      "6": "DOWNLOAD_",
    },
    MODULES: {
      "1": {},
      "2": {
        "5": "_CONTRACT_TYPE_",
      },
      "3": {
        "6": "_REPORTS_",
      },
      "4": {
        "7": "_USER_MANAGEMENT_",
      },
      "5": {
        "8": "_TEMPLATES_",
      },
      "6": {
        "9": "_CLAUSES_",
      },
      "7": {
        "10": "_NOTIFICATIONS_",
      },
    },
  };
  permissionsValue: Permissions = new Permissions();
  loggedinUser: Users = null;
  loggedInOrg: Organisation = null;
  loggedinPermissions: ModulesSubmodulesPermissionsByRole[] = null;
  loggedinAllModulesSubmodules: ModulesSubmodulesPermissionsMaster = null;
  loggedIn: boolean;
  currentURL: string;
  userAuthBaseUrl: String;
  allUsers: Users[] = [];
  pendingContractsForApproval = [];
  pendingContractsForReview = [];

  initiatedContracts = [];
  pendingSignatureContracts = [];
  expireContracts = [];
  expiredContracts = [];
  contractsWorth = [];
  contractStatus = [];
  contractBaseUrl: String;
  contracttypeBaseUrl: String;
  onboarding: Onboarding;
  onboardingDone: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private toast: ToastrService,
  ) {
    this.contractBaseUrl = environment.contractApiURL;
    this.contracttypeBaseUrl = environment.contractTypeApiURL;
  }

  // signInWithUsernamePassword(

  //   data
  // ) {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //     }),
  //   };
  //   return new Promise((resolve, reject) => {

  //     this.http
  //       .post("http://35.189.94.89:8081/api1/authenticateuser", data, httpOptions)
  //       .toPromise()
  //       .then((response: any) => {
  //         if (response) {
  //           this.loggedIn = true;
  //           this.loggedinUser = response as Users;
  //           localStorage.setItem("access_token", response.jwt);
  //           localStorage.setItem("currentUser", JSON.stringify(this.loggedinUser));
  //           // Clear SSO flag for regular login
  //           localStorage.removeItem("ssoLogin");
  //           this.http
  //           .get(this.contractBaseUrl + "/tenants/" + this.loggedinUser.tenantId).toPromise().then((res: Organisation) => {
  //             this.loggedInOrg = res as Organisation;
  //             console.log(this.loggedInOrg,"tenent")
  //           });
  //           this.http
  //             .get(
  //               this.contractBaseUrl +
  //               "/tenants/" +
  //               this.loggedinUser.tenantId +
  //               "/roleModuleSubModulePermission/users/" +
  //               this.loggedinUser.id
  //             )
  //             .toPromise()
  //             .then((res) => {
  //               localStorage.setItem("currentPermissions", JSON.stringify(res));
  //               this.loggedinPermissions =
  //                 res as ModulesSubmodulesPermissionsByRole[];
  //               this.http
  //                 .get(this.contractBaseUrl + "/modulesSubmodulesPermissions")
  //                 .toPromise()
  //                 .then((res: ModulesSubmodulesPermissionsMaster) => {
  //                   this.loggedinAllModulesSubmodules =
  //                     res as ModulesSubmodulesPermissionsMaster;
  //                   localStorage.setItem(
  //                     "currentModuleSubmodule",
  //                     JSON.stringify(res)
  //                   );
  //                   this.settingUpRolesAndPermissions()
  //                     .then((r) => {
  //                       resolve(true);

  //                     })

  //                     .catch((r) => {
  //                       this.loggedIn = false;
  //                       this.loggedinUser = null;
  //                       this.loggedinPermissions = null;
  //                       localStorage.setItem("currentUser", "null");
  //                       localStorage.setItem("currentPermissions", "null");
  //                       reject(r);
  //                     });
  //                 });
  //             });
  //         }
  //       }).catch((error) => {
  //         reject(error);
  //       })
  //   });
  // }



  signInWithUsernamePassword(

    data
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return new Promise((resolve, reject) => {

      this.http
        .post(this.contractBaseUrl + "/authenticateuser", data, httpOptions)
        .toPromise()
        .then((response: any) => {
          console.log(response.isSuccess, 'sada')
          if (response.isSuccess) {
            this.loggedIn = true;
            this.loggedinUser = response.body as Users;
            localStorage.setItem("currentUser", JSON.stringify(this.loggedinUser));
            this.http
              .get(this.contractBaseUrl + "/tenants/" + this.loggedinUser.tenantId).toPromise().then((res: Organisation) => {
                this.loggedInOrg = res as Organisation;
                console.log(this.loggedInOrg, "tenent")
              });
            this.http
              .get(
                this.contractBaseUrl +
                "/tenants/" +
                this.loggedinUser.tenantId +
                "/roleModuleSubModulePermission/users/" +
                this.loggedinUser.id
              )
              .toPromise()
              .then((res) => {
                localStorage.setItem("currentPermissions", JSON.stringify(res));
                this.loggedinPermissions =
                  res as ModulesSubmodulesPermissionsByRole[];
                this.http
                  .get(this.contractBaseUrl + "/modulesSubmodulesPermissions")
                  .toPromise()
                  .then((res: ModulesSubmodulesPermissionsMaster) => {
                    this.loggedinAllModulesSubmodules =
                      res as ModulesSubmodulesPermissionsMaster;
                    localStorage.setItem(
                      "currentModuleSubmodule",
                      JSON.stringify(res)
                    );
                    this.settingUpRolesAndPermissions()
                      .then((r) => {
                        resolve(true);

                      })

                      .catch((r) => {
                        this.loggedIn = false;
                        this.loggedinUser = null;
                        this.loggedinPermissions = null;
                        localStorage.setItem("currentUser", "null");
                        localStorage.setItem("currentPermissions", "null");
                        reject(r);
                      });
                  });
              });
          }
        }).catch((error) => {
          reject(error);
        })
    });
  }
  settingUpRolesAndPermissions() {
    return new Promise((resolve, reject) => {
      let atleast_one_contract_add_permission = false;
      // commented to solve login issue for new tenant
      if (this.loggedinPermissions.length == 0) {
        reject(false);
      }
      this.loggedinPermissions.forEach(
        (value: ModulesSubmodulesPermissionsByRole, index) => {
          let permission_allowed = value.permissionIds.split(",");
          let property_name = "";

          if (value.moduleId == 1) {
            let module = this.loggedinAllModulesSubmodules.moduleDTOs.find(
              (o) => {
                if (o.id == value.moduleId) return true;
                return false;
              }
            );
            let sub_module = module.subModuleDTOs.find((o) => {
              if (o.id == value.subModuleId) return true;
              return false;
            });
            let contract_type_name = sub_module.name.toUpperCase();
            property_name = "_CONTRACT_" + contract_type_name + "_";

            this.permissionsValue[property_name + "ADD_"] = false;
            this.permissionsValue[property_name + "EDIT_"] = false;
            this.permissionsValue[property_name + "VIEW_"] = false;
            this.permissionsValue[property_name + "DELETE_"] = false;
            this.permissionsValue[property_name + "UPLOAD_"] = false;
            this.permissionsValue[property_name + "DOWNLOAD_"] = false;

          } else {


            property_name =
              this.permissionTypes.MODULES[value.moduleId][value.subModuleId];
            this.permissionsValue[property_name + "ADD_"] = false;
            this.permissionsValue[property_name + "EDIT_"] = false;
            this.permissionsValue[property_name + "VIEW_"] = false;
            this.permissionsValue[property_name + "DELETE_"] = false;
            this.permissionsValue[property_name + "UPLOAD_"] = false;
            this.permissionsValue[property_name + "DOWNLOAD_"] = false;

          }
          for (let i = 0; i < permission_allowed.length; i++) {
            if (value.moduleId == 1 && permission_allowed[i] == "1")
              atleast_one_contract_add_permission = true;

            if (permission_allowed[i] != "")
              this.permissionsValue[
                property_name +
                this.permissionTypes.PERMISSIONS[permission_allowed[i]]
              ] = true;
          }
          if (index == this.loggedinPermissions.length - 1) {
            this.permissionsValue["_CONTRACT_ADD_"] =
              atleast_one_contract_add_permission;
            resolve(true);
          }
        }
      );
    });
  }
  updatePassword(email: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contractBaseUrl + "/forgotpassword?email=" + email, {
          responseType: "text",
        })
        .toPromise().then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  signOutOfUsernamePassword(redirect_url: string) {
    // Check if user logged in via SSO
    const isSSOLogin = localStorage.getItem("ssoLogin") === "true";

    if (isSSOLogin) {
      this.clearUserData();

      window.location.href = this.contractBaseUrl + "/logout";
    } else {
      this.clearUserData();
      this.router.navigate(["/login"]);
      window.location.reload();
    }
  }

  private clearUserData(): void {
    this.loggedIn = false;
    this.loggedinUser = null;
    this.loggedinPermissions = null;
    localStorage.setItem("currentUser", "null");
    localStorage.setItem("currentPermissions", "null");
    localStorage.removeItem("ssoLogin");
    localStorage.removeItem("access_token");
  }
  getAllUsers() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contractBaseUrl + "/users")
        .toPromise()
        .then((res) => {
          this.allUsers = res as Users[];
          resolve(this.allUsers.length);
        });
    });
  }

  getAllTenantUsers() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contractBaseUrl + `/tenants/${this.loggedinUser.tenantId}/users`)
        .toPromise().then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getTurnAroundTime() {
    return this.http.get(this.contractBaseUrl + `/getAgreementTurnaroundTime/${this.loggedinUser.tenantId}`)
  }
  ApproveContract(contractId: number) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/Approve?ContractId=" +
          contractId +
          "&ApproverId=" +
          this.loggedinUser.id +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise().then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error);
        });

    });
  }
  RejectContract(contractId: number, reason: String) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/Reject?ContractId=" +
          contractId +
          "&ApproverId=" +
          this.loggedinUser.id +
          "&reason=" +
          reason +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise().then((res) => {
          resolve(res)
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getAllContractsForApprovalByLoggedInUser() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/GetContractApproversByUser?UserId=" +
          this.loggedinUser.id +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: Array<any>) => {
          this.pendingContractsForApproval = res;
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getAllContractsForApproval() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl + `/Validation/GetContractApproversByUser?tenantId=${this.loggedinUser.tenantId}`
        )
        .toPromise()
        .then((res: any) => {
          console.log(res, 'appov')
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getAllContractsForReview() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          `/Validation/GetContractReviwersByUser?tenantId=${this.loggedinUser.tenantId}`
        )
        .toPromise()
        .then((res: any) => {
          console.log(res, 'Reviwe')
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getAllContractsForReviewByLoggedInUser() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/GetContractReviwersByUser?UserId=" +
          this.loggedinUser.id +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: Array<any>) => {
          this.pendingContractsForReview = res;
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractInitiatedByUser() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/GetContractInitiatedByUser?UserId=" +
          this.loggedinUser.id +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: Array<any>) => {
          this.initiatedContracts = res;
          resolve(true);
        }).catch((error: any) => {
          reject(error);
        });
    });
  }

  ////////////////pendingSignature on dashboard///////////
  getPendingSignContracts() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/Validation/GetContractbyPendingSignature?UserId=" +
          this.loggedinUser.id +
          "&tenantId=" +
          this.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: Array<any>) => {
          this.pendingSignatureContracts = res;
          resolve(true);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  //////////////////////Expire agreement//////////
  getExpireContract(days): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(
        this.contractBaseUrl + `/user/${this.loggedinUser.id}/tenants/${this.loggedinUser.tenantId}/days/${days}/contractsGoingToExpire`
      ).toPromise().then((res: any) => {
        this.expireContracts = res.body
        if (res && res.body && Array.isArray(res.body)) {
          const worth = res.body.map(contract => contract.Amount);
          const totalWorth = worth.reduce((acc, curr) => acc + curr, 0);
          resolve(totalWorth);
        }
      }).catch((error: any) => {
        reject(error);
      });
    });

  }
  ///////////////////Expired Agreement////////////
  getExpiredContract(days) {
    return new Promise((resolve, reject) => {
      this.http.get(
        this.contractBaseUrl + `/tenants/${this.loggedinUser.tenantId}/days/${days}/contractsExpired`
      ).toPromise().then((res: any) => {
        this.expiredContracts = res.body
        resolve(res)
      }).catch((error: any) => {
        reject(error);
      });
    });
  }
  /////////////////stagnantContract/////////////
  getStagnantContract(days) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + `/stagnantContracts/${this.loggedinUser.tenantId}/${days}`)
        .toPromise().then((res: any) => {
          console.log(res.body, 'win')
          resolve(res)
        }).catch((error: any) => {
          reject(error)
        })
    })
  }
  //////////////////////pending Status//////////////
  getContractStatus(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>(this.contractBaseUrl + `/user/${this.loggedinUser.id}/tenants/${this.loggedinUser.tenantId}/contractsInPendingStatus`)
        .toPromise()
        .then((res: any) => {
          this.contractStatus = res.body
          if (res && res.body && Array.isArray(res.body)) {
            const amounts = res.body.map(contract => contract.Amount);
            const totalAmount = amounts.reduce((acc, curr) => acc + curr, 0);
            resolve(totalAmount);
          } else {
            reject(new Error('Invalid API response'));
          }
        })
        .catch((error: any) => {
          reject(error);
        });

    });
  }


  createTenant(file: File) {
    const formData = new FormData();
    formData.append("organisationLogo", file);
    // var temp = '{"name":"'+name+'","contractId":'+this.Contract.id+',"documentPath":"'+name+'","createdBy":"'+this.userFullName+'","createdDate":"'+new Date().toISOString()+'","updatedBy":"'+this.userFullName+'","updatedDate":"'+new Date().toISOString()+'","isDeleted":false}';
    //formData.append('supportingDocumentDto',temp);
    // var temp = '{"name":"'+name+'","contractId":'+this.Contract.id+',"documentPath":"'+name+'","createdBy":"'+this.userFullName+'","createdDate":"'+new Date().toISOString()+'","updatedBy":"'+this.userFullName+'","updatedDate":"'+new Date().toISOString()+'","isDeleted":false}';
    //formData.append('supportingDocumentDto',temp);
    let params = new URLSearchParams();
    for (let key in this.onboarding) {
      params.set(key, this.onboarding[key]);
    }
    params.set("createdBy", this.onboarding.firstName.toString());
    params.set("updatedBy", this.onboarding.firstName.toString());
    return this.http
      .post(
        this.contractBaseUrl + "/tenants?" + params.toString(),
        formData
      )
      .toPromise();
  }
  sendMail(tenentId: number) {
    var baseURL = window.location.host;
    return this.http
      .put(
        this.contractBaseUrl +
        "/tenants/email-verification/" +
        tenentId +
        "?baseURL=http://" +
        baseURL +
        "/app/verify-email?code=",
        {},
        { responseType: "text" }
      )
      .toPromise();
  }

  tokenConfirmation(token: string) {
    return this.http
      .get(this.contractBaseUrl + "/tenants/verify-email?code=" + token, {
        responseType: "text",
      })
      .toPromise();
  }

  firstUserUpdateUser(password) {
    return new Promise((resolve, reject) => {
      let data = this.loggedinUser;
      data.updateDate = new Date();
      data.isFirstLogin = false;
      data.password = password;
      let url =
        this.contractBaseUrl +
        "/tenants/" +
        data.tenantId +
        "/users/" +
        data.id;

      this.http
        .put(url, data)
        .toPromise()
        .then((res: Users) => {
          this.loggedinUser = res;
          localStorage.setItem("currentUser", JSON.stringify(this.loggedinUser));
          resolve(true);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Initiate SSO login by redirecting to OAuth2 provider
   */
  initiateSSOLogin(): void {
    const ssoUrl = this.contractBaseUrl + "/oauth2/authorization/azure";
    window.location.href = ssoUrl;
  }

  /**
   * Validate SSO token received from OAuth2 callback
   */
  validateSSOToken(token: string, username: string): Promise<any> {
    const validateTokenUrl = `${this.contractBaseUrl}/validate-token`;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams()
        .set('token', token)
        .set('username', username)
        .set('jwt', token)
    };

    return new Promise((resolve, reject) => {
      this.http
        .post(validateTokenUrl, null, httpOptions)
        .toPromise()
        .then((response: any) => {
          if (response && response.isSuccess && response.body) {
            this.loggedIn = true;
            this.loggedinUser = response.body as Users;
            // Store JWT token
            localStorage.setItem("access_token", response.body.jwt);
            localStorage.setItem("currentUser", JSON.stringify(this.loggedinUser));
            // Mark that user logged in via SSO
            localStorage.setItem("ssoLogin", "true");

            // Load tenant/organization information
            this.http
              .get(this.contractBaseUrl + "/tenants/" + this.loggedinUser.tenantId)
              .toPromise()
              .then((res: Organisation) => {
                this.loggedInOrg = res as Organisation;
              })
              .catch((error) => {
                console.error("Error loading tenant:", error);
              });

            // Load user permissions
            this.http
              .get(
                this.contractBaseUrl +
                "/tenants/" +
                this.loggedinUser.tenantId +
                "/roleModuleSubModulePermission/users/" +
                this.loggedinUser.id
              )
              .toPromise()
              .then((res) => {
                localStorage.setItem("currentPermissions", JSON.stringify(res));
                this.loggedinPermissions =
                  res as ModulesSubmodulesPermissionsByRole[];
                this.http
                  .get(this.contractBaseUrl + "/modulesSubmodulesPermissions")
                  .toPromise()
                  .then((res: ModulesSubmodulesPermissionsMaster) => {
                    this.loggedinAllModulesSubmodules =
                      res as ModulesSubmodulesPermissionsMaster;
                    localStorage.setItem(
                      "currentModuleSubmodule",
                      JSON.stringify(res)
                    );
                    this.settingUpRolesAndPermissions()
                      .then((r) => {
                        resolve(true);
                      })
                      .catch((r) => {
                        this.loggedIn = false;
                        this.loggedinUser = null;
                        this.loggedinPermissions = null;
                        localStorage.setItem("currentUser", "null");
                        localStorage.setItem("currentPermissions", "null");
                        reject(r);
                      });
                  });
              })
              .catch((error) => {
                console.error("Error loading permissions:", error);
                // Still resolve if permissions fail to load, but log the error
                resolve(true);
              });
          } else {
            reject(new Error(response?.message || 'Token validation failed'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
